import React, { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import { Box, CircularProgress } from '@mui/material';
import {
  GET_ALL_PORTFOLIOS_BY_AGE_MONTHS_CREDITS,
  GET_ALL_PORTFOLIOS_BY_CAPITAL_PER_YEAR,
  GET_ALL_PORTFOLIOS_BY_CITIES,
  GET_ALL_PORTFOLIOS_BY_COMPANIES,
  GET_ALL_PORTFOLIOS_BY_CREDITS_PER_YEAR,
  GET_ALL_PORTFOLIOS_BY_ECONOMIC_ACT,
  GET_ALL_PORTFOLIOS_BY_GENDERS,
} from '../queries';
import { DashBoardPortfolioByAgeV } from '../../../../components/wallet/dashboard/dashBoardPortfolioByAge';

const CHART_COLORS: string[] = [
  '#FFB7B2',
  '#FFDAC1',
  '#E2F0CB',
  '#B5EAD7',
  '#C7CEEA',
  '#FF9AA2',
  '#FFD1A9',
  '#D5AAFF',
  '#A8D8EA',
  '#ABEBC6',
  '#F8B4C8',
  '#D7BDE2',
  '#D5DBDB',
];

export const DashBoardPortfolioByAgeC: React.FC = () => {
  const bgColors = useMemo(
    () => Array.from({ length: 4 }, (_, i) => CHART_COLORS[i % CHART_COLORS.length]),
    []
  );

  const { data: portfolioGenders, loading: l1 } = useQuery(GET_ALL_PORTFOLIOS_BY_GENDERS, {
    fetchPolicy: 'no-cache',
  });

  const { data: portfolioEconomicAct, loading: l2 } = useQuery(GET_ALL_PORTFOLIOS_BY_ECONOMIC_ACT, {
    fetchPolicy: 'no-cache',
  });

  const { data: portfolioCities, loading: l3 } = useQuery(GET_ALL_PORTFOLIOS_BY_CITIES, {
    fetchPolicy: 'no-cache',
  });

  const { data: portfolioCapitalPerYear, loading: l4 } = useQuery(
    GET_ALL_PORTFOLIOS_BY_CAPITAL_PER_YEAR,
    { fetchPolicy: 'no-cache' }
  );

  const { data: portfolioCreditsPerYear, loading: l5 } = useQuery(
    GET_ALL_PORTFOLIOS_BY_CREDITS_PER_YEAR,
    { fetchPolicy: 'no-cache' }
  );

  const { data: portfolioCompanies, loading: l6 } = useQuery(GET_ALL_PORTFOLIOS_BY_COMPANIES, {
    fetchPolicy: 'no-cache',
  });

  const { data: portfolioAvgMonths, loading: l7 } = useQuery(
    GET_ALL_PORTFOLIOS_BY_AGE_MONTHS_CREDITS,
    { fetchPolicy: 'no-cache' }
  );

  const isLoading = l1 || l2 || l3 || l4 || l5 || l6 || l7;

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 10 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <DashBoardPortfolioByAgeV
      portfolioGenders={portfolioGenders?.getReportByGenders}
      portfolioEconomicAct={portfolioEconomicAct?.getReportByEconomyActivities}
      portfolioCities={portfolioCities?.getReportByCityOfResidence}
      portfolioCapitalPerYear={portfolioCapitalPerYear?.getReportCapitalPerYear}
      portfolioCreditsPerYear={portfolioCreditsPerYear?.getReportCreditsPerYear}
      portfolioCompanies={portfolioCompanies?.getReportByCompanies}
      portfolioAvgMonths={portfolioAvgMonths?.getReportAvgMonthsCredits}
      bgColors={bgColors}
    />
  );
};
